// Пункт меню продукта в форме контракта (submenu — вложенный MenuNode) → форма
// ProductRail (children — плоский массив вложенных пунктов, рекурсивно тот же вид).
function toRailItem(it) {
    const fromSubmenu = (it.submenu?.sections ?? []).flatMap((s) => (s.items ?? []).map(toRailItem));
    const fromChildren = (it.children ?? []).map(toRailItem);
    const children = [...fromSubmenu, ...fromChildren];
    return { id: it.id, label: it.label, icon: it.icon, count: it.count, disabled: it.disabled, ...(children.length ? { children } : {}) };
}
export function toRailMenu(m) {
    if (!m)
        return null;
    return {
        title: m.title, sub: m.sub, productId: m.productId,
        sections: (m.sections ?? []).map((s) => ({ title: s.title, items: (s.items ?? []).map(toRailItem) })),
    };
}
